const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/translations/translations_common.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        actionApply: 'Anwenden',
        labelSelectedEntry: 'Gewählt: {name}',
        actionCancel: 'Abbrechen',
        actionChange: 'Ändern',
        actionClose: 'Schliessen',
        actionConfirm: 'Bestätigen',
        actionCopy: 'Duplizieren',
        actionDelete: 'Löschen',
        actionDiscard: 'Verwerfen',
        actionEdit: 'Bearbeiten',
        actionLogOut: 'Abmelden',
        actionObjectEntry: 'Eingabe',
        actionObjectEvent: 'Massnahme',
        actionObjectEvents: 'Massnahmen',
        actionObjectMessage: 'Nachricht',
        actionRefresh: 'Aktualisieren',
        actionReset: 'Zurücksetzen',
        actionSave: 'Speichern',
        actionShowDetails: 'Details anzeigen',
        discardInputDialogText: 'Die Daten werden nicht gespeichert. Wollen Sie Ihre Eingabe verwerfen?',
        discardInputDialogTitle: 'Eingabe verwerfen?',
        done: 'Fertig',
        error: 'Fehler',
        errorFailedToLoadCase: 'Falldaten konnten nicht geladen werden',
        errorFailedToLoadPatient: 'Patientendaten konnten nicht geladen werden',
        labelFrom: 'Ab',
        labelUntil: 'Bis',
        new: 'Neu',
        no: 'Nein',
        noItems: 'Keine Einträge',
        noResults: 'Keine Treffer',
        none: 'Keine',
        now: 'Jetzt',
        ok: 'OK',
        savedSuccessfully: 'Erfolgreich gespeichert',
        savingFailed: 'Speichern fehlgeschlagen',
        settings: 'Einstellungen',
        success: 'Erfolgreich',
        titleDeleteItem: '{item} löschen',
        titleDiscardItem: '{item} verwerfen',
        tryAgain: 'Ihre Anpassungen konnten nicht übernommen werden. Bitte versuchen Sie es später noch einmal.',
        yes: 'Ja',
    },
    __RELATIVE_SOURCE_FILE__
);
